import * as React from 'react';
import { Route } from 'react-router';

import { StatsigProvider } from '@coursera-web/statsig';

import { Route as CourseraRoute } from '@coursera/react-router';

import PreferenceCenterApp from 'bundles/account-settings/components/PreferenceCenterApp';
import SettingsApp from 'bundles/account-settings/components/SettingsApp';
import UnsubscribeApp from 'bundles/account-settings/components/UnsubscribeApp';
import ZoomAccountLinkingRedirect from 'bundles/account-settings/components/ZoomAccountLinkingRedirect';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import OrgScopedHomeFeatureProvider from 'bundles/unified-common/providers/OrgScopedHomeFeatureProvider';
import UserExperienceContextProvider from 'bundles/unified-common/providers/UserExperienceContextProvider';

const UnsubscribePage = loadOnRoute(() => import('bundles/account-settings/components/UnsubscribePage'));
const PreferenceCenterPage = loadOnRoute(() => import('bundles/account-settings/components/PreferenceCenterPage'));
const NotFound = loadOnRoute(() => import('bundles/phoenix/components/NotFound'));

const SettingsAppWithStatsig = (props: React.ComponentProps<typeof SettingsApp>) => (
  <StatsigProvider>
    <UserExperienceContextProvider>
      <OrgScopedHomeFeatureProvider>
        <SettingsApp {...props} />
      </OrgScopedHomeFeatureProvider>
    </UserExperienceContextProvider>
  </StatsigProvider>
);

export default (
  <Route path="/">
    <CourseraRoute
      component={SettingsAppWithStatsig}
      path="/account-settings(/ssr)"
      handle={{ tracking: { data: () => ({ page: { type: 'account_settings' } }) } }}
    />

    <Route path="/account/unsubscribe" component={UnsubscribeApp}>
      <Route path=":token" getComponent={UnsubscribePage} />
    </Route>

    <Route path="/account/preferences" component={PreferenceCenterApp}>
      <Route path=":token" getComponent={PreferenceCenterPage} />
    </Route>

    <Route path="/zoom-account-linking" component={ZoomAccountLinkingRedirect} />
    <Route path="/zoom-account-linking-dev" component={ZoomAccountLinkingRedirect} />
    <Route path="*" getComponent={NotFound} />
  </Route>
);
